import { AccessTime, TrendingDown, TrendingUp } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useGlobalMarketTopPriceChangesContext } from "../../../context/global-market/GlobalMarketTopPriceChangesContext";
import { COLORS } from "../../../ui/Theme";
import useResponsive from "../../../components/hooks/useResponsive";

const durationItems = [
  { label: "1 هفته", value: 7 },
  { label: "1 ماه", value: 30 },
  { label: "3 ماه", value: 90 },
  { label: "6 ماه", value: 180 },
  { label: "1 سال", value: 365 },
];

const GlobalMarketTopPriceChangesForm = () => {
  const { symbolChecked, setSymbolChecked } =
    useGlobalMarketTopPriceChangesContext();

  const { isMd } = useResponsive();

  const [searchParams, setSearchParams] = useSearchParams();

  const params = new URLSearchParams(searchParams);

  const currentDuration = searchParams.get("duration") || "30";
  const currentTopPriceChanges = searchParams.get("price_changes") || "inc";

  const handlePriceChanges = (priceChanges) => {
    params.set("price_changes", priceChanges);
    setSearchParams(params);
  };

  const handleDuration = (e) => {
    const duration = e.target.value;

    params.set("duration", duration);
    setSearchParams(params);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: "10px" },
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          justifyContent: { xs: "center", md: "flex-start" },
          width: { xs: "100%", md: "auto" },
        }}
      >
        {/* duration */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width: { xs: "50%", md: "auto" },
          }}
        >
          {isMd && (
            <Typography sx={{ fontSize: "12px", color: COLORS.GRAY }}>
              مدت زمان
            </Typography>
          )}
          <Select
            value={currentDuration}
            onChange={handleDuration}
            sx={{
              width: { xs: "100%", md: "120px" },
            }}
            startAdornment={
              !isMd && (
                <InputAdornment position="start">
                  <AccessTime sx={{ color: COLORS.GRAY }} />
                </InputAdornment>
              )
            }
          >
            {durationItems.map((duration) => (
              <MenuItem key={duration.value} value={duration.value}>
                {duration.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ display: { xs: "none", md: "block" } }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: "50%", md: "250px" },
            gap: 0.5,
            padding: "4px",
            bgcolor: COLORS.INPUTBG,
            borderRadius: "12px",
          }}
        >
          <button
            onClick={() => handlePriceChanges("inc")}
            className={"btn"}
            style={{
              color: COLORS.GREEN,
              background:
                currentTopPriceChanges === "inc"
                  ? COLORS.SOFTGREEN
                  : COLORS.SOFTGRAY,
            }}
          >
            {isMd && (
              <Typography sx={{ fontSize: "10px" }}>بیشترین افزایش</Typography>
            )}

            <TrendingUp sx={{ width: "18px" }} />
          </button>
          <button
            onClick={() => handlePriceChanges("dec")}
            style={{
              color: COLORS.RED,
              background:
                currentTopPriceChanges === "dec"
                  ? COLORS.SOFTRED
                  : COLORS.SOFTGRAY,
            }}
            className={"btn"}
          >
            {isMd && (
              <Typography sx={{ fontSize: "10px" }}>بیشترین کاهش</Typography>
            )}

            <TrendingDown sx={{ width: "18px" }} />
          </button>
        </Box>
      </Box>
      <Box
        sx={{
          bgcolor: COLORS.INPUTBG,
          p: "8px 10px",
          borderRadius: "12px",
          width: { xs: "100%", md: "auto" },
          // justifyContent: "center",
          display: "flex",
        }}
      >
        <FormControlLabel
          sx={{
            m: 0,
          }}
          control={
            <Checkbox
              checked={symbolChecked}
              sx={{ fontSize: "14px", p: 0 }}
              onChange={(e) => setSymbolChecked(e.target.checked)}
            />
          }
          label="فقط نمادی های بورسی"
        />
      </Box>
    </Box>
  );
};

export default GlobalMarketTopPriceChangesForm;
